// UUID v4 senza trattini per `event_id`, e generatore del `trace_id` di pagina.
// Usa `crypto.getRandomValues` quando disponibile, con fallback a `Math.random`.

function randomBytes(length: number): Uint8Array {
  const bytes = new Uint8Array(length)
  const cryptoObj = (globalThis as { crypto?: Crypto }).crypto
  if (cryptoObj && typeof cryptoObj.getRandomValues === 'function') {
    cryptoObj.getRandomValues(bytes)
    return bytes
  }
  for (let i = 0; i < length; i++) {
    bytes[i] = Math.floor(Math.random() * 256)
  }
  return bytes
}

/// UUID v4 canonico (con trattini).
export function uuidV4(): string {
  const b = randomBytes(16)
  // Versione (4) e variante (10xx) secondo RFC 4122.
  b[6] = (b[6]! & 0x0f) | 0x40
  b[8] = (b[8]! & 0x3f) | 0x80
  const hex: string[] = []
  for (let i = 0; i < 16; i++) hex.push(b[i]!.toString(16).padStart(2, '0'))
  return (
    hex.slice(0, 4).join('') +
    '-' +
    hex.slice(4, 6).join('') +
    '-' +
    hex.slice(6, 8).join('') +
    '-' +
    hex.slice(8, 10).join('') +
    '-' +
    hex.slice(10, 16).join('')
  )
}

/// UUID v4 senza trattini — formato di `event_id` accettato dall'ingest.
export function uuidV4NoDashes(): string {
  return uuidV4().replace(/-/g, '')
}
